var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 400",
    enableBackground: "new 0 0 400 400",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 101.3,
    y: 137.4,
    fill: "#E26A6A",
    width: 52.3,
    height: 52.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.3,
    y: 65.1,
    fill: "#00ADEE",
    width: 52.3,
    height: 52.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.3,
    y: 210.1,
    fill: "#26A560",
    width: 52.3,
    height: 52.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.4,
    y: 282.5,
    fill: "#F6921E",
    width: 52.3,
    height: 52.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.8,
    y: 137.4,
    fill: "#E26A6A",
    width: 52.3,
    height: 52.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00ADEE",
    d: "M28.8,117.5V75.1c0-5.5,4.5-10,10-10h42.3v52.3H28.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.8,
    y: 210.1,
    fill: "#26A560",
    width: 52.3,
    height: 52.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6921E",
    d: "M81.3,334.9H38.9c-5.5,0-10-4.5-10-10v-42.3h52.3V334.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.8,
    y: 137.4,
    fill: "#E26A6A",
    width: 52.3,
    height: 52.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.8,
    y: 65.1,
    fill: "#00ADEE",
    width: 52.3,
    height: 52.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.8,
    y: 210.1,
    fill: "#26A560",
    width: 52.3,
    height: 52.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.9,
    y: 282.5,
    fill: "#F6921E",
    width: 52.3,
    height: 52.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.7,
    y: 137.4,
    fill: "#E26A6A",
    width: 52.3,
    height: 52.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00ADEE",
    d: "M318.7,117.5V65.1h42.3c5.5,0,10,4.5,10,10v42.3H318.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.7,
    y: 210.1,
    fill: "#26A560",
    width: 52.3,
    height: 52.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6921E",
    d: "M361.2,334.9h-42.3v-52.3h52.3v42.3C371.2,330.4,366.7,334.9,361.2,334.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.2,
    y: 137.4,
    fill: "#E26A6A",
    width: 52.3,
    height: 52.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.2,
    y: 65.1,
    fill: "#00ADEE",
    width: 52.3,
    height: 52.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.2,
    y: 210.1,
    fill: "#26A560",
    width: 52.3,
    height: 52.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.4,
    y: 282.5,
    fill: "#F6921E",
    width: 52.3,
    height: 52.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.84bac1f859d0783647745b8c90a8f927.svg";
export { ForwardRef as ReactComponent };